import React from "react";
import "./FooterLast.css";

const FooterText = () => {
  return (
    <div className="pb-5 text-center">
      <p className="mb-5 pb-5">
        {" "}
        <small id="">Ⓒ</small> {new Date().getFullYear} Copyright by Amar Net
        Bill. All Rights Reserved.
      </p>
    </div>
  );
};

export default FooterText;
